import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "../lib/cart";
import { gbp } from "../lib/store";

const track = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};

export const ProductCard = ({ p }) => {
  const { add } = useCart();
  const onAdd = () => {
    add(p);
    toast.success(`${p.name} added`, { description: "Ready for click & collect." });
  };
  return (
    <motion.article layout initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, scale: 0.96 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }} onMouseMove={track} data-testid={`guna-product-card-${p.sku}`}
      className="spot group relative flex flex-col overflow-hidden rounded-2xl border border-black/10 bg-[#FFFBEB] p-3">
      <div className="arch relative aspect-[4/5] overflow-hidden bg-[#FFFFFF]">
        <img src={p.image} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
        <div className="absolute inset-0 bg-[radial-gradient(70%_60%_at_50%_35%,transparent,rgba(13,13,15,0.7))]" />
        {p.tag && <span className="font-mono-g absolute left-1/2 top-6 -translate-x-1/2 whitespace-nowrap rounded-full bg-[#FFC93C] px-3 py-1 text-[10px] uppercase tracking-[0.2em] text-[#1C1917]">{p.tag}</span>}
      </div>
      <div className="relative z-[3] flex flex-1 flex-col px-2 pb-2 pt-5">
        <div className="font-mono-g flex justify-between text-[11px] uppercase tracking-[0.15em] text-stone-600">
          <span>{p.size}</span><span>{p.abv !== "—" ? `${p.abv} ABV` : p.origin}</span>
        </div>
        <h3 className="font-display mt-2 text-2xl leading-tight text-[#1C1917]">{p.name}</h3>
        <p className="mt-1 flex-1 text-sm text-stone-600">{p.note}</p>
        <div className="mt-5 flex items-center justify-between">
          <span className="font-mono-g text-lg text-[#D62828]" data-testid={`guna-price-${p.sku}`}>{gbp(p.price)}</span>
          <motion.button whileTap={{ scale: 0.9 }} onClick={onAdd} data-testid={`guna-add-to-cart-${p.sku}`}
            className="flex items-center gap-1.5 rounded-full border border-black/15 px-4 py-2 text-sm text-[#1C1917] transition-colors hover:border-[#D62828] hover:bg-[#D62828] hover:text-[#FFFFFF]">
            <Plus className="h-4 w-4" /> Add
          </motion.button>
        </div>
      </div>
    </motion.article>
  );
};
